import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import Bubble from "./bubble/Bubble";
import { propTypes } from "mobx-react";
import SeparateGrid from "../../../module-common/SeparateGrid";

// this component is responsible for rendering messages
export default class MessageListView extends Component {
  static propTypes = {
    id: PropTypes.number,
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        content: PropTypes.string,
        fromAgent: PropTypes.bool,
        withArrow: PropTypes.bool,
        time: PropTypes.instanceOf(moment),
        avatar: PropTypes.string,
        channel: PropTypes.string,
        noNeed: PropTypes.bool,
        originalPost: propTypes.string,
        channelName: propTypes.string,
        scrollRef: PropTypes.func // func to pass scrollbar ref to parent comp
      })
    ),
    onEndReached: PropTypes.func
  };
  static defaultProps = { messages: [] };
  scrollHeight = 0; // always updated with scroll area height

  componentDidMount() {
    // first mount always scroll to bottom
    this.scroller.scrollToBottom();
  }

  componentWillUpdate() {
    // remember scroll height before new message arrive
    this.scrollHeight = this.scroller.getScrollHeight();
  }

  // after new props arrived, adjust scroller position
  componentDidUpdate(prevProps) {
    // dont modify scroll position if prev or current messages length is 0
    const prevMessagesLength = prevProps.messages.length;
    const currentMessagesLength = this.props.messages.length;

    // only modify scroll position if there is difference in messages length
    if (currentMessagesLength !== prevMessagesLength) {
      // get prev and current top message id
      const prevTopMessageId =
        prevMessagesLength > 0
          ? prevProps.messages[prevMessagesLength - 1].id
          : -1;
      const currentTopMessageId =
        currentMessagesLength > 0
          ? this.props.messages[currentMessagesLength - 1].id
          : -1;

      // if top message id is different, then we are loading prev data
      if (prevTopMessageId !== currentTopMessageId) {
        // adjust scrollbar to avoid top position sticking
        this.scroller.scrollTop(
          this.scroller.getScrollHeight() - this.scrollHeight
        );
      }
    }
  }

  render() {
    const scrollRef = this.props.scrollRef;
    return (
      <Wrapper>
        <Scrollbars
          ref={ref => {
            this.scroller = ref;
            if (scrollRef) scrollRef(ref);
          }}
          onScrollFrame={this.onScrollFrame}
        >
          <Padding>{this.renderMessages()}</Padding>
        </Scrollbars>
      </Wrapper>
    );
  }

  // render messages with heading date and corrent position
  renderMessages = () => {
    const { messages } = this.props;
    let flagNewCase = true;
    const renders = [];
    let prevMessage = null;
    messages.forEach(message => {
      const {
        id,
        avatar,
        time,
        replyName,
        labels,
        replyContent,
        channelName,
        originalPost,
        ...rest
      } = message;

      // decide to show date separator or not
      let dateSeparator;

      if (
        prevMessage &&
        prevMessage.time
          .clone()
          .startOf("day")
          .diff(time.clone().startOf("day"), "days") >= 1
      ) {
        dateSeparator = (
          <DateSeparator key={"separator-" + id}>
            {prevMessage.time.format("LL")}
          </DateSeparator>
        );
      }

      if (dateSeparator) renders.push(dateSeparator);
      if (flagNewCase && message.isOldCase) {
        renders.push(<SeparateGrid />);
        flagNewCase = false;
      }

      // decide to show avatar or not
      let bubbleAvatar;
      if (
        dateSeparator ||
        prevMessage === null ||
        prevMessage.avatar !== avatar
      ) {
        bubbleAvatar = avatar;
      }

      renders.push(
        <Bubble
          key={id}
          id={id}
          avatar={bubbleAvatar}
          labels={labels}
          time={time.format("hh:mm A")}
          replyContent={replyContent}
          replyName={replyName}
          channelName={channelName}
          originalPost={originalPost}
          {...rest}
        />
      );
      prevMessage = message;
    });

    // add last date separator on top
    if (prevMessage) {
      renders.push(
        <DateSeparator key="separator-top">
          {prevMessage.time.format("LL")}
        </DateSeparator>
      );
    }

    // reverse renders to get chat like view
    return renders.reverse();
  };

  // track scrolling for infinite loading purpose
  onScrollFrame = event => {
    // if at end of border, trigger event
    if (event.top === 0) {
      const onEndReached = this.props.onEndReached;
      onEndReached && onEndReached();
    }
  };
}

const Wrapper = styled.div`
  position: relative;
  flex: 2;
`;
const Padding = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;
const DateSeparator = styled.div`
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/message-list/MessageListView.js